<template>
  <div class="booking-box-up-coming-event-photographer">
    <div v-if="tempData">
      <div class="box1">
        <div class="item">
          <dropdown-calendar-type-2
            v-model="tempData.date"
            :mode="tempMode"
          ></dropdown-calendar-type-2>
        </div>
        <div class="item">
          <dropdown-time-type-2
            v-model="tempData.reservation"
            :mode="tempMode"
          ></dropdown-time-type-2>
        </div>
        <div class="item">
          <div class="title">Location</div>
          <div class="text">Search by</div>
        </div>
      </div>
      <transition name="fade">
        <div v-if="tempMode" class="message-box" :class="{ edit: tempMode }">
          <div class="container">
            <div class="profile-image">
              <img v-imageLoading="tempData.userProfileImage" />
            </div>
            <div class="contents">
              <div class="author">
                Shooting with
                <span class="name" v-text="tempData.userName"></span>
              </div>
              <div class="comment">
                {{ tempData.location.address.detail }}
                <div class="location" @click="viewMap">View map</div>
              </div>
            </div>
            <div class="buttons">
              <button class="message" @click="tempMode = false">CANCEL</button>
              <button class="edit">OK</button>
            </div>
            <div class="buttons-cancel">
              <button class="request-cancel" @click="tempMode = false">
                REQUEST TO CANCEL
              </button>
            </div>
          </div>
        </div>
        <div v-else class="message-box">
          <div class="container">
            <div class="profile-image">
              <img v-imageLoading="tempData.userProfileImage" />
            </div>
            <div class="contents">
              <div class="author">
                Shooting with
                <span class="name" v-text="tempData.userName"></span>
              </div>
              <div
                class="comment"
                v-if="tempData.status == 'decline'"
                v-text="tempData.declineMessage"
              ></div>
              <div
                class="comment"
                v-else
                v-text="tempData.location.address.detail"
              ></div>
            </div>
            <div class="buttons">
              <div v-if="tempData.status == 'request'" class="wait-message">
                Waiting for photographer to accept your request
              </div>
              <button v-else class="message" @click="message">MESSAGE</button>
              <button
                v-if="tempData.status != 'decline'"
                class="edit"
                @click="done"
              >
                DONE
              </button>
              <button v-else class="decline">Declined</button>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="no-data" v-else>
      <div class="message">There is no Message</div>
    </div>
  </div>
</template>

<script>
import DropdownCalendarType2 from '../common/DropdownCalendarType2'
import DropdownTimeType2 from '../common/DropdownTimeType2'
import * as types from '../../store/mutation-types'
import { createMessage } from '../../api/message'
import { updateRequestReservation } from '../../api/reservation'
import mixCommon from '../../mixin/common'

export default {
  mixins: [mixCommon],
  name: 'booking-box-up-coming-event-photographer',
  components: {
    DropdownTimeType2,
    DropdownCalendarType2
  },
  props: {
    data: {
      default: () => ({
        date: '04-01-2018',
        time: '1:4',
        refNo: '213',
        profileImage: require('../../assets/images/common/temp-profile.jpg'),
        comment:
          'at Chantrey House, 98 Buckingham Palace Rd, Belgravia, London SW1W 0SS',
        photographerName: 'Miky',
        location: {
          lat: 55.01657628017477,
          lng: -7.309233337402361
        }
      }),
      type: Object
    },
    mode: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      tempData: {},
      tempMode: false
    }
  },
  created() {
    this.tempData = this.data
    this.tempMode = this.mode
    this.tempData.time = '1:5'
  },
  mounted() {
    console.log(this.tempData)
  },
  methods: {
    message() {
      // (photographerId, userId, serviceId, photographerProfileImage, userProfileImage)
      createMessage(
        this.tempData.photographerId,
        this.tempData.uid,
        this.tempData.id,
        this.tempData.photographerProfileImage,
        this.tempData.userProfileImage,
        this.tempData.userName,
        this.tempData.photographerName
      ).then(res => {
        console.log('message create response:', res)
        this.$router.push({ path: '/photographer/message/' + this.tempData.id })
      })
    },
    buttonAction(actionName) {
      this.$emit('action', { action: actionName, data: this.tempData })
    },
    viewMap() {
      this.$store
        .dispatch(types.SET_MODAL_GOOGLE_MAP_COMPONENT, {
          component: 'recommend',
          propData: this.tempData.location
        })
        .then(() => {
          this.$store.dispatch(types.SET_MODAL_COMPONENT, {
            component: 'googleMap',
            active: true,
            type: 'full'
          })
        })
    },
    done() {
      updateRequestReservation(this.tempData.id, { status: 'done' }).then(
        () => {
          this.$router.push({ path: '/photographer/booking/upload' })
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.booking-box-up-coming-event-photographer {
  /*border: 1px solid #c8c8c8;*/
  .box1 {
    background-color: #f5f5f5;
    display: flex;
    border-bottom: 1px solid #c8c8c8;
    border-top: 1px solid #c8c8c8;

    .item {
      width: 100%;
      height: 80px;

      &:nth-child(1) {
        border-right: 1px solid #c8c8c8;
        border-left: 1px solid #c8c8c8;
      }

      &:nth-child(2) {
        border-right: 1px solid #c8c8c8;
      }

      &:nth-child(3) {
        border-right: 1px solid #c8c8c8;
      }

      .title {
        margin: 20px 0 0 20px;
        /*border: 1px solid red;*/
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 1px;
      }

      .text {
        margin: 10px 0 0 20px;
        font-size: 16px;
        font-weight: 300;
        letter-spacing: 1px;
      }
    }
  }

  .message-box {
    .container {
      height: 133px;
      display: flex;
      justify-content: space-between;
      border-left: 1px solid #c8c8c8;
      border-right: 1px solid #c8c8c8;
      border-bottom: 1px solid #c8c8c8;

      .profile-image {
        width: 131px;
        height: 131px;
        position: relative;

        img {
          object-fit: contain;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: 100px;
          height: 100px;
        }
      }

      .contents {
        width: 70%;
        margin: 18px 0 18px 0;
        /*border: 1px dotted red;*/
        .author {
          font-weight: 600;
        }

        .comment {
          margin: 10px 0 0 0;
          width: 700px;
          height: 71px;
          /*border: 1px solid red;*/
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .location {
          cursor: pointer;
          color: blue;
        }
      }

      .buttons {
        width: 200px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        button {
          width: 150px;
          height: 50px;
          font-size: 14px;
          font-weight: 300;
          letter-spacing: 1px;
          cursor: pointer;
          outline: none;
        }

        .message {
          background-color: white;
          border: 1px solid #c8c8c8;
          margin: 0 0 10px 0;

          &:active {
            color: #000000;
          }
        }

        .wait-message {
          width: 250px;
          height: 52px;
          font-size: 16px;
          font-weight: 300;
          letter-spacing: 1px;
          text-align: right;
          color: #000000;
          position: relative;
          right: 55px;
        }

        .edit {
          border: 0;
          background-color: #000bff;
          color: white;
        }

        .decline {
          border: 0;
          background-color: #ff3226;
          color: white;
          cursor: help;
        }
      }
    }
  }

  .edit {
    position: relative;
    height: 200px;

    .container {
      .contents {
        width: 90%;
      }

      .buttons {
        position: absolute;
        width: 320px;
        right: 0;
        bottom: 0;
        justify-content: space-between;
        flex-direction: row;
        /*align-items: center;*/
        .message {
          margin: 0;
        }
      }

      .buttons-cancel {
        width: 200px;
        height: 50px;
        position: absolute;
        left: 0;
        bottom: 0;

        button {
          width: 100%;
          height: 50px;
          font-size: 14px;
          font-weight: 300;
          letter-spacing: 1px;
          cursor: pointer;
          outline: none;
        }

        .request-cancel {
          border: 0;
          background-color: #ffffff;
          color: #000000;
          border: 1px solid #c8c8c8;
        }
      }
    }
  }

  .no-data {
    height: 200px;
    position: relative;

    .message {
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 200px;
      text-align: center;
      height: 20px;
    }

    background-color: #f5f5f5;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
  transition: opacity 0.5s;
}
</style>
